import React, { Component } from 'react';
import Head from 'next/head'
import { Header, Footer, Document, PageWrapper } from '../components'

import { fetchDocuments } from '../api/documents'

class DocumentsPage extends Component {
  static async getInitialProps({props}) {
    const documentsPromise = fetchDocuments(props.organisationId);
    return {
        organisationId: props.organisationId,
        documents: await documentsPromise
    }
  }

  render() {
    const { organisationId, organisation, pages } = this.props
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Documents`}</title>
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <h1>{'Documents'}</h1>
          {this.props.documents.data.map(d =>
            <Document key={d.id} document={d} />
          )}
        </div>
        <Footer />
      </div>
    )
  }

}
export default PageWrapper(DocumentsPage)
